import * as actions from '../actions/user';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import {requestNotificationsIndicator} from "../actions/notifications";
import {isAdminUser, isAragUser, isSolicitorUser} from "../helpers/functions";
import { push,goBack } from 'connected-react-router';
import sampleCombine from "xstream/extra/sampleCombine";

export function requestForgotPassword(sources) {
    const query$ = sources.ACTION
        .filter(action => action.type === ActionTypes.SEND_FORGOT_PASSWORD);

    const request$ = query$
        .map(action => ({
            url: BASE_URL + 'api/account/resetPassword',
            category: 'requestForgotPassword',
            method: 'POST',
            send: action.payload.sendBody,
            type: 'application/json',
            withCredentials: true
        }));

    const httpResponse$ = sources.HTTP
        .select('requestForgotPassword')
        .map( (response) => response.replaceError( (err) => xs.of(err)))
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.sendForgotPasswordSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    }
}

export function requestForgotPasswordFailed(sources) {
    const httpResponse$ = sources.HTTP
        .select('requestForgotPassword')
        .map( (response) => response.replaceError( (err) => xs.of(err)))
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.sendForgotPasswordFailed(response));

    return {
        ACTION: httpResponse$
    }
}

export function requestGetSessionExpirationDate(sources) {
    const query$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_SESSION_EXPIRATION_DATE);

    const request$ = query$
        .map(action => ({
            url: BASE_URL + 'api/SessionExpiration'  ,
            category: 'requestGetSessionExpirationDate',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));


    let httpResponse$ = sources.HTTP
        .select('requestGetSessionExpirationDate')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getSessionExpirationDateSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestGetSessionExpirationDateFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestGetSessionExpirationDate')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.getSessionExpirationDateFail(response));

    return {
        ACTION: httpResponse$
    };
}

export function redirectAfterAcceptingToba(sources) {
    const state$ = sources.STATE;
    const locationPathname$ = state$.map(state => state.router.location.pathname);
    let httpResponse$ = sources.ACTION
        .filter(action => action.type === ActionTypes.RECEIVE_ACCEPT_TOBA)
        .compose(sampleCombine(locationPathname$))
        .map( ([response, locationPathname ]) => locationPathname.includes('/accept-toba')?
            goBack()
            :
            push(locationPathname)
        );

    return {
        ACTION: httpResponse$
    };
}

export function redirectAragUserAfterLogIn(sources) {
    const state$ = sources.STATE;
    const locationPathname$ = state$.map(state => state.router.location.pathname);
    let httpResponse$ = sources.HTTP
        .select('users')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .filter(response =>  isAragUser(response.body.roles) && !isAdminUser(response.body.roles))
        .compose(sampleCombine(locationPathname$))
        .filter(  ([response, locationPathname ]) => locationPathname === '/')
        .map(response => push('/application-and-policies'));

    return {
        ACTION: httpResponse$
    }
}

export function redirectSolicitorUserToPoliciesAfterLogIn(sources) {
    const state$ = sources.STATE;
    const locationPathname$ = state$.map(state => state.router.location.pathname);
    let httpResponse$ = sources.HTTP
        .select('users')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .filter(response =>  isSolicitorUser(response.body.roles))
        .compose(sampleCombine(locationPathname$))
        .filter(  ([response, locationPathname ]) => locationPathname === '/solicitor-home')
        .map(response => push('/application-and-policies'));

    return {
        ACTION: httpResponse$
    }
}

export function logIn(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_TO_LOGIN)
        .map(action => ({
            url: BASE_URL + `api/account/login`,
            category: 'users',
            method: 'POST',
            type: 'application/json',
            send: {
                userName: action.payload.username,
								email: action.payload.email,
                password: action.payload.password
            },
          withCredentials: true
        }));

    //below httpResponse$ listens for for http responses and after filtering ,in order to get
    //the successful http post requests, it updates the redux store with the logged in user
    let httpResponse$ = sources.HTTP
        .select('users')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveLogInResponse(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function rejectLogIn(sources) {
    let httpResponse$ = sources.HTTP
        .select('users')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.displayRejectAuthDialogBox(response));

    return {
        ACTION: httpResponse$
    }
}

export function getVersion(sources) {

	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.RECEIVE_LOG_IN_RESPONSE)
		.map(action => ({
			url: BASE_URL + `api/Version`,
			category: 'version',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('version')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveVersion(response.text))

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function requestPendingToba(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_TOBA)
        .map(action => ({
            url: BASE_URL + 'api/toba/toba',
            category: 'pendingToba',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    //below httpResponse$ listens for for http responses and after filtering ,in order to get
    //the successful http post requests, it updates the redux store with the logged in user
    let httpResponse$ = sources.HTTP
        .select('pendingToba')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveToba(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveFailedResponseGetPendingToba(sources) {
    let httpResponse$ = sources.HTTP
        .select('pendingToba')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveToba(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestAcceptPendingToba(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_ACCEPT_TOBA)
        .map(action => ({
            url: BASE_URL + 'api/agents/acceptToba/' + action.payload,
            category: 'acceptToba',
            method: 'POST',
            type: 'application/json',
            withCredentials: true
        }));

    //below httpResponse$ listens for for http responses and after filtering ,in order to get
    //the successful http post requests, it updates the redux store with the logged in user
    let httpResponse$ = sources.HTTP
        .select('acceptToba')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveAcceptToba(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveFailedResponseAcceptPendingToba(sources) {
    let httpResponse$ = sources.HTTP
        .select('acceptToba')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToAcceptToba(response));

    return {
        ACTION: httpResponse$
    };
}

export function logout(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.LOGOUT)
		.map(action => ({
			url: BASE_URL + `api/account/logoff`,
			category: 'logoff',
			method: 'POST',
			type: 'application/json',
			withCredentials: true
		}));

	return {
		HTTP: request$
	};
}

export function unauthorized(sources){

	let httpResponse2$ = sources.HTTP
		.select('getSolicitors')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 401)
		.map(response => actions.logout());

	return{
	  ACTION: httpResponse2$
  }
}

//When a user logs in ask for the notifications indicator


export function askForNotificationsIndicatorAfterLogIn(sources) {
	let httpResponse$ = sources.HTTP
		.select('users')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.filter(response => response.body.roles[0] !== 'Administrator')
		.map(response => requestNotificationsIndicator());

	return {
		ACTION: httpResponse$
	}
}

export function requestUnlockAragUser(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.UNLOCK_ARAG_USER)
        .map(action => ({
            url: BASE_URL + `api/users/AragUsers/${action.payload.aragUserId}/unlock`,
            category: 'requestUnlockAragUser',
            method: 'PATCH',
            type: 'application/json',
            withCredentials: true
        }));

    //below httpResponse$ listens  for http responses and after filtering ,in order to get
    //the successful http post requests, it updates the redux store with the posted new solicitors
    let httpResponse$ = sources.HTTP
        .select('requestUnlockAragUser')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.unlockAragUserSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };

}

export function requestUnlockAragUserFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestUnlockAragUser')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200 )
        .map(response => actions.unlockAragUserFailed(response));

    return {
        ACTION: httpResponse$
    }
}





